export class Selectable<T> {
  constructor(public v: T, public selected = false) {
  }
}
